import { useTranslation } from "react-i18next";

import "./styles.css";

function WordsContainer() {
  const { t } = useTranslation();
  return (
    <div className="lp-main-headline-container">
      <h1 className="lp-main-healine">{t("landingPage.headline.part1")}</h1>
      <h1 className="lp-main-healine bold">{t("landingPage.headline.part2")}</h1>
    </div>
  );
}

export default WordsContainer;
